import React, { useState, useEffect, useMemo } from 'react'
import { Row, Col, Table, Button, DatePicker, Tooltip, Modal, Input, Menu } from 'antd'
import moment from 'moment'
import { getMachineLog, getMachineRequest, getWeekRequest } from '../../../../../services/others/work-arrangement-services'
import SweetAlertService from '../../../../../services/lib/utils/sweet-alert-service'
import { ApiRequest } from '../../../../../services/api/api'
import { getRandomKey } from '../../../../../services/lib/utils/helpers'
import WorkLogDialog from '../work-arrangement/work-log-dialog' // Import the WorkLogDialog component
import { CalculatorOutlined, ClockCircleOutlined, LinkOutlined, UserOutlined, FilterOutlined, SearchOutlined, ToolOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'

interface machine2{
  machineId: number,
  machineName: string,
  machineTypeId: number,
  picture: string
}
interface arrangement {
  arrangementId: number,
  machineId: number,
  workingDate: string,
  createdAt: string,
  operatorIds: number[],
  maintenance: number,
  dailyCount: number,
  uptime: number,
  createdByNavigation: null,
  machine: machine2,
  operators: {
    employeeId: number,
    firstName: string,
    lastName: string,
    email: string,
    mobile: string,
    isSales: number,
    createdAt: string,
    userName: string,
    deptId: number,
    roleId: number,
    active: number
  }[]
  [key: string]: any; // 使用索引签名支持动态属性

}

const MachineLog: React.FC = () => {

  const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'))
  const [arrangeData, setArrangeData] = useState<arrangement[]>([])
  const [allMachines, setAllMachines] = useState<machine2[]>([])
  const [resetflag, setResetflag] = useState<string>()
  const [isWorkLogDialogOpen, setIsWorkLogDialogOpen] = useState(false)
  const [selectedUserData, setSelectedUserData] = useState<any>(null)
  const [nameFilter, setNameFilter] = useState<string>('')

  useEffect(() => {
  document.title = "Production Record";
}, []);
  useEffect(() => {
    if (selectedDate !== null && selectedDate !== "") {
      Promise.all([getMachineLog(selectedDate), getMachineRequest()])
        .then(([res1, res2]) => {
          // console.log(res1.data.data,'machineLog')
          // console.log(res2.data.data,'machine')
          const machines = dataTransfer(res2.data.data, 'machines')
          const tableData = mergeTest(machines, res1.data.data, selectedDate);
          // console.log(tableData)
          setAllMachines(machines)
          setArrangeData(tableData);
          // debugger
        })
    }
  }, [selectedDate,resetflag]);
  
  const weekday = (day: any, selectedDay?:string,) => {
    return moment(selectedDay).isoWeekday(day).format('YYYY-MM-DD')
  }
  
  const dataTransfer = (data:any, filter: string) => {
    const newArray:any = []
    if (filter === 'machines') {
      data.map((res:machine2) => {
        newArray.push({
          id: res.machineId,
          img: res.picture,
          name: res.machineName,
          type_id: res.machineTypeId
        }
        )
      })
    }

    if (filter === 'users') {
      data.map((res:any) => {
        newArray.push({
          id: res.employeeId,
          name: res.firstName + ' ' + res.lastName
        })
      })
    }
    // console.log(newArray)
    return newArray
  }
  
  const mergeTest = (machines: machine2[], allMachinesOperateTime: arrangement[], selectedDay: string) => {
    const newArray: arrangement[] = [];
    // debugger
    // 如果 allMachinesOperateTime 为空，初始化一个空的周计划
    if (allMachinesOperateTime.length === 0) {
      machines.forEach((res: machine2) => {
        newArray.push({
          machine: res,
          arrangementId: 0,
          machineId: res.machineId,
          workingDate: selectedDay,
          createdAt: '',
          dailyCount: 0,
          uptime: 0,
          operatorIds: [],
          maintenance: 0,
          createdByNavigation: null,
          operators: []
        });
      });
      return newArray;
    }
  
    // 遍历每台机器
    machines.forEach((res: any) => {
      const obj: arrangement = {
        machine: res,
        arrangementId: 0,
        machineId: res.machineId,
        workingDate: selectedDay,
        createdAt: '',
        dailyCount: 0,
        uptime: 0,
        operatorIds: [],
        maintenance: 0,
        createdByNavigation: null,
        operators: []
      };
  
      // 遍历所有机器的操作时间
      for (let i = 0; i < allMachinesOperateTime.length; i++) {
        if (res.id === allMachinesOperateTime[i].machineId) {
          // 获取当前操作时间的日期
          const workingDate = allMachinesOperateTime[i].workingDate.slice(0, 10);
          // debugger
          // 遍历一周的每一天
          for (let day = 1; day <= 7; day++) {
            const dayKey = moment().isoWeekday(day).format('dddd').toLowerCase() as keyof arrangement; // 获取星期几的键（如 "monday"）
            if (workingDate === weekday(day, selectedDay)) {
              obj[dayKey] = {
                user: allMachinesOperateTime[i].operators,
                // user: {
                //   // id: allMachinesOperateTime[i].operatorIds[0],
                //   name: allMachinesOperateTime[i].operators?.[0]?.firstName && allMachinesOperateTime[i].operators?.[0]?.lastName ? allMachinesOperateTime[i].operators?.[0]?.firstName + ' ' + allMachinesOperateTime[i].operators?.[0]?.lastName : '',
                // },
                arrangeId: allMachinesOperateTime[i].arrangementId,
                maintenance: allMachinesOperateTime[i].maintenance,
                dailyCount: allMachinesOperateTime[i].dailyCount,
                uptime: allMachinesOperateTime[i].uptime,
                machineCount: allMachinesOperateTime[i].machineCount,
              };
            }
          }
        }
      }
  
      newArray.push(obj);
    });
  
    return newArray;
  };

  const selectHandler = (data: any, dateString: string) => {
    setSelectedDate(dateString)
  }

  // Modified function to open WorkLogDialog instead of fillHours
  // const openWorkLogDialog = ( day: number,record: any) => {
  //   // 找到包含当前用户的日期键
  //   const dayKey = Object.keys(record).find(key => 
  //     key !== 'machine' && 
  //     record[key]?.user?.length > 0
  //   );
  //   debugger
  //   // 传递机器数据，包含机器信息和安排信息
  //   setSelectedUserData({
  //     // ...user,
  //     machineData: {
  //       machine: record.machine,
  //       maintenance: dayKey ? record[dayKey]?.maintenance || 0 : 0,
  //       arrangeId: dayKey ? record[dayKey]?.arrangeId || 0 : 0
  //     }
  //   });
  //   setIsWorkLogDialogOpen(true);
  // };
  const openWorkLogDialog = (day: number, record: any) => {
    // Map day number to day name
    const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayKey = dayMap[day]; // e.g., 3 -> 'wednesday'
  
    // Safety check
    const dayData = record[dayKey] || {};
    // 传递机器数据，包含机器信息和安排信息
    // 计算这一格的 workingDate (基于 selectedDate + day 推算), 用于仅当日生产记录查询
    const cellWorkingDate = weekday(day, selectedDate)
    setSelectedUserData({
      machineData: {
        machine: record.machine,
        maintenance: dayData.maintenance || 0,
        arrangeId: dayData.arrangeId || 0,
        dailyCount: dayData.dailyCount || 0,
        uptime: dayData.uptime || 0,
        users: dayData.user || [],
        workingDate: cellWorkingDate,
        selectedDate: selectedDate,
      }
    });
  
    setIsWorkLogDialogOpen(true);
  };
  // Handle WorkLogDialog close
  const handleWorkLogDialogClose = (success: boolean) => {
    setIsWorkLogDialogOpen(false);
    setSelectedUserData(null);
    
    if (success) {
      // Refresh the data if the work log was successfully saved
      setResetflag(getRandomKey());
    }
  };

  const generateDayColumn = (day: number, selectedDate: string) => {
    const dayKey = moment().isoWeekday(day).format('dddd').toLowerCase(); // 获取星期几的键（如 "monday"）
    const dayTitle = `${moment().isoWeekday(day).format('dddd')} (${weekday(day, selectedDate).slice(5)})`; // 列标题

    return {
      title: dayTitle,
      key: dayKey,
      render: (text: any, record: any) => {
        // console.log(record[dayKey],'record[dayKey]')
        const dayData = record[dayKey]
        return (
        <div style={{  gap: '1px', padding: '0 px 0' }}>
          
           <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1px', padding: '1px 0' }}>
            {dayData?.machineCount !== undefined && dayData?.machineCount !== null && dayData?.machineCount !== 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                <CalculatorOutlined style={{ color: '#1890ff' }} />
                <span>{dayData?.machineCount}</span>
              </div>
            )}
                  {/* JSON 调试显示 */}
            {/* <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: '4px', borderRadius: '4px' }}>
              {day},
              {selectedDate},
              {JSON.stringify(record, null, 2)}
            </pre> */}
            {/* 显示 uptime（如果有） */}
            {dayData?.uptime !== undefined && dayData?.uptime !== null && dayData?.uptime !== 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                <ClockCircleOutlined style={{ color: '#52c41a' }} />
                <span>{dayData?.uptime ? `${Math.floor(dayData.uptime / 60)}h${dayData.uptime % 60}m` : '___'}</span>
              </div>
            )}
          </div>
          {dayData?.user?.length === 0 && (
            <div onClick={() => openWorkLogDialog(day,record)} style={{ display: 'flex',cursor: 'pointer',alignItems: 'center', gap: '4px', color: '#52c41a' }}>
              <span>✔</span>
            </div>
          )}
            <div style={{ margin: '0', padding: '0' }}  onClick={() => openWorkLogDialog(day,record)}>
              {record[dayKey]?.user?.map((user: any) => (
                <div key={user.employeeId} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px', borderRadius: '4px', transition: 'background-color 0.2s' }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'} onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                <div style={{ fontSize: '13px', fontWeight: '500', color: '#333', backgroundColor: '#e6f7ff', borderRadius: '6px', padding: '2px 6px', margin: '0', lineHeight: '1.2' }}>
                    <Tooltip title={user.firstName + ' ' + user.lastName}>
                      {user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)}
                    </Tooltip>
                    <span style={{ color: '#666', marginLeft: '4px', fontSize: '12px', cursor: 'pointer' }}>
                    {user.duration 
                      ? `${user.duration >= 60 ? `${Math.floor(user.duration / 60)}h ` : ''}${user.duration % 60}m`
                      : '___'}
                      </span>
                  </div>
                </div>
              ))
                || <div style={{ minHeight: '10px' }}> </div>}
            </div>
          </div>
        );
        // );
      },
    };
  };

  const columns = useMemo(() => [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nameFilter ? (
            <ToolOutlined style={{ fontSize: '14px', flexShrink: 0 }} />
          ) : (
            <span style={{ flexShrink: 0, whiteSpace: 'nowrap' }}>Name</span>
          )}
          <Input
            placeholder="Search..."
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
            style={{ width: '120px', fontSize: '12px' }}
            prefix={<SearchOutlined />}
            allowClear
          />
        </div>
      ),
      dataIndex: ['machine', 'name'],
      key: 'name',
      width: 200,
      filteredValue: nameFilter ? [nameFilter] : null,
      onFilter: (value: any, record: any) =>
        record.machine?.name?.toString().toLowerCase().includes((value as string).toLowerCase()),
    },
    ...Array.from({ length: 7 }, (_, i) => generateDayColumn(i + 1, selectedDate)), // 动态生成周一到周日的列
  ], [nameFilter, selectedDate]);

  return (
    <div>
      <Row style={{padding: '1rem 0'}}>
        <Col span={8}>
          <DatePicker onChange={selectHandler} defaultValue={moment(selectedDate, 'YYYY-MM-DD')} style={{width: '100%'}} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={arrangeData}
            pagination={false}
            sticky={{
              offsetHeader: 0,
            }}
          />
        </Col>
      </Row>
      
      {/* WorkLogDialog Modal */}
      <Modal
        title={`工作记录${selectedUserData?.machineData?.machine?.name ? ' - ' + selectedUserData.machineData.machine.name : ''}`}
        open={isWorkLogDialogOpen}
        onCancel={() => handleWorkLogDialogClose(false)}
        footer={null}
        width={900}
        centered
      >
        {isWorkLogDialogOpen && (
          <WorkLogDialog 
            onDialogClose={handleWorkLogDialogClose}
            // userData={selectedUserData}
            machineData={selectedUserData?.machineData}
            // selectedDate={selectedDate}
          />
        )}
      </Modal>
    </div>
  )
}

export default MachineLog


export const ButtonsForPageLink = () => {
  const history = useHistory()
  const data = [
    {name: 'Suborder', link: '/suborder'},
    {name: 'Packaging', link: '/packaging'},
    {name: 'Production Record', link: '/work-arrangement-present'},
  ]
  return (
    <div>
      {
        data.map((row: any, i: any) => <Button icon={<LinkOutlined />} type="dashed" onClick={() => history.push(row.link)} style={{marginRight: '1rem'}} key={i.toString()}>{row.name}</Button>)
      }
    </div>
  )
}
